module.exports = __webpack_public_path__ + "static/media/project-4.d88d880a.jpg";